import { Crisp } from "crisp-sdk-web"

export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig()

  if (!window.localStorage.getItem('sato48:impersonate')) {
    Crisp.configure(config.public.crisp.websiteId)
  }
})
